import React, {Component} from 'react'
import {withRouter, Link} from 'react-router-dom'
import Axios from 'axios'
import {withCookies} from 'react-cookie'

import ReactJson from 'react-json-view'

import socialImg from './imgs/Rectangle.png'
import timelineBar from './imgs/TimelineBar.png'
import ytRadioPic from './imgs/ytRadio.jpg'
import balanceGamingPic from './imgs/BalanceGaming2.jpg'
import twitchFirePic from './imgs/TwitchFire.jpg'

import Stats from './Stats'

class Home extends Component {
  constructor(props) {
    super(props)

    let {cookies, match} = props

    let dir = match?.params?.dir || ''

    this.state = {
      dir,
    }
    console.log('dir', dir)
  }

  componentDidMount() {
    console.log('home Mount')
  }

  render() {
    let {screenHeight, screenWidth} = this.props
    if (this.state.dir == 'stats') {
      return <Stats screenHeight={screenHeight} screenWidth={screenWidth} />
    }

    return (
      <div>
        <div className="nameTitle col-xs-12">
          <div className="firstNameTitle">jeff</div>

          <div className="lastNameTitle">gabriel</div>
        </div>

        <div className="col-xs-12 subTitle">Web Dev & Designer</div>

        <div className="col-xs-12 titleSocial">
          <a target="_blank" href="http://www.twitter.com/JeffKGabriel">
            <div className="socialLink fa fa-twitter" aria-hidden="true"></div>
          </a>

          <img height="1" width="22" style={{marginTop: 11, marginLeft: 5}} src={socialImg} />

          <a target="_blank" href="http://www.github.com/JeffKGabriel">
            <div className="socialLink fa fa-github" style={{marginLeft: 6}} aria-hidden="true"></div>
          </a>
        </div>

        <div className=" col-xs-12 col-sm-offset-2 col-sm-8 work">
          <div className="workThumbs">
            <div className="box workThumb">
              <a target="_blank" href="http://ytradio.xyz/">
                <img src={ytRadioPic} />
              </a>
            </div>

            <div className="box workThumb">
              <a target="_blank" href="http://balance-gaming.com/">
                <img src={balanceGamingPic} />
              </a>
            </div>

            <div className="box workThumb">
              <a target="_blank" href="http://twitchFire.tv/">
                <img src={twitchFirePic} />
              </a>
            </div>
          </div>
        </div>

        <div className="toolsLibraries col-sm-8 col-sm-offset-2 col-lg-6 col-lg-offset-3 col-xs-12">
          <div className="col-md-6 col-xs-12">
            <div className="col-xs-12 toolsTitle">Tools</div>

            <div
              className="col-xs-12"
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                marginTop: 8,
              }}
            >
              <div className="toolList" style={{marginRight: 40}}>
                <a target="_blank" href="https://facebook.github.io/react/">
                  react / native
                </a>
                <a target="_blank" href="https://www.sketchapp.com/">
                  sketch
                </a>
                <a target="_blank" href="https://www.docker.com/">
                  docker
                </a>
                <a target="_blank" href="http://getbootstrap.com/">
                  bootstrap
                </a>
                <a target="_blank" href="https://letsencrypt.org/">
                  letsencrypt
                </a>
              </div>

              <div className="toolList">
                <a target="_blank" href="https://webpack.js.org/">
                  webpack
                </a>
                <a target="_blank" href="https://www.mongodb.com/">
                  mongo db
                </a>
                <a target="_blank" href="https://firebase.google.com/">
                  firebase
                </a>
                <a target="_blank" href="https://nodejs.org/">
                  node
                </a>
                <a target="_blank" href="https://github.com/git/git">
                  git
                </a>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-xs-12">
            <div className="col-xs-12 toolsTitle">Libraries</div>

            <div
              className="col-xs-12"
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                marginTop: 8,
              }}
            >
              <div className="toolList" style={{marginRight: 40}}>
                <a target="_blank" href="https://expressjs.com/">
                  express
                </a>
                <a target="_blank" href="http://redux.js.org/">
                  redux
                </a>
                <a target="_blank" href="https://github.com/mzabriskie/axios">
                  axios
                </a>
                <a target="_blank" href="http://pm2.keymetrics.io/">
                  pm2
                </a>
                <a target="_blank" href="https://babeljs.io/">
                  babel
                </a>
              </div>

              <div className="toolList">
                <a target="_blank" href="http://chaijs.com/">
                  mocha & chai
                </a>
                <a target="_blank" href="https://socket.io/">
                  socket.io
                </a>
                <a target="_blank" href="http://mongoosejs.com/">
                  mongoose
                </a>
                <a target="_blank" href="https://github.com/ReactTraining/react-router">
                  react-router
                </a>
                <a target="_blank" href="https://github.com/react-community/react-navigation">
                  react-navigation
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="timeLineBox col-xs-12 col-md-8 col-md-offset-2 ">
          <div className="col-xs-offset-3 col-xs-9">
            <div className="timelineTitle col-xs-7">About</div>
          </div>

          <div className="col-xs-3 hidden-xs">
            <div style={{height: 500, float: 'right', paddingTop: 6}}>
              <img height="314" width="61" src={timelineBar} />
            </div>
          </div>

          <div style={{fontSize: 20, display: 'table', marginBottom: 11}}>
            <div className="col-xs-12">Georgia Tech, Bachelors in Computer Engineering</div>
            <div className="col-xs-12" style={{fontSize: 18}}>
              <ul>
                <li>C, ARM, MatLab</li>
                <li>PCB, Computer Architecture</li>
                <li>GreyHat Club (Infosec)</li>
                <li>Minor in Psychology</li>
              </ul>
            </div>
          </div>

          <div style={{fontSize: 20, display: 'table', marginBottom: 11}}>
            <div className="col-xs-12">Macys System & Technology, Devops & CICD - 2 years</div>
            <div className="col-xs-12" style={{fontSize: 18}}>
              <ul>
                <li>Docker</li>
                <li>Fullstack JS (Node, React & Angular)</li>
                <li>API Design & Implementation</li>
                <li>Unix Automation</li>
              </ul>
            </div>
          </div>

          <div style={{fontSize: 20, display: 'table'}}>
            <div className="col-xs-12">Moving East -> West Coast USA</div>
            <div className="col-xs-12" style={{fontSize: 18}}>
              <ul>
                <li>Coding Passion Projects</li>
                <li>Helping Friends</li>
                <li>Remote Work / Freelance</li>
              </ul>
            </div>
          </div>

          <div></div>
        </div>

        <div className="passionsBox col-xs-12 col-sm-offset-2 col-sm-8">
          <div className="passionsTitle col-xs-offset-2 col-xs-8">Passions & Interests</div>

          <div className="col-xs-12 col-sm-6 col-lg-4 passionBlock">
            <div className="passionBlockContent">
              <div className="passionBlockTitle">Web Tech</div>

              <ul>
                <li>JS ES6</li>
                <li>Blockchain (ETH)</li>
                <li>IPFS</li>
                <li>WebVR</li>
              </ul>
            </div>
          </div>

          <div className="col-xs-12 col-sm-6 col-lg-4 passionBlock">
            <div className="passionBlockContent">
              <div className="passionBlockTitle">Product Design</div>

              <ul>
                <li>Virality</li>
                <li>Onboarding / Churn</li>
                <li>Monitization Strategy</li>
              </ul>
            </div>
          </div>

          <div className="col-xs-12 col-sm-6 col-lg-4 passionBlock">
            <div className="passionBlockContent">
              <div className="passionBlockTitle">User Psychology</div>

              <ul>
                <li>Product Experience</li>
                <li>Habits</li>
                <li>Gameification</li>
              </ul>
            </div>
          </div>

          <div className="col-xs-12 col-sm-6 col-lg-4 passionBlock">
            <div className="passionBlockContent">
              <div className="passionBlockTitle">Design</div>

              <ul>
                <li>Clean / Minimal</li>
                <li>Fluidity</li>
                <li>Feedback</li>
                <li>Orientation</li>
              </ul>
            </div>
          </div>

          <div className="col-xs-12 col-sm-6 col-lg-4 passionBlock">
            <div className="passionBlockContent">
              <div className="passionBlockTitle">Mobile Apps</div>

              <ul>
                <li>Social Connectivity</li>
                <li>Ecosystem</li>
                <li>User Extension</li>
              </ul>
            </div>
          </div>

          <div className="col-xs-12 col-sm-6 col-lg-4 passionBlock">
            <div className="passionBlockContent">
              <div className="passionBlockTitle">Market Trends</div>

              <ul>
                <li>Supply & Demand</li>
                <li>Innovation</li>
                <li>User Adoption</li>
                <li>Attention Marketing</li>
              </ul>
            </div>
          </div>

          <div className="col-xs-12 col-sm-6 col-lg-4 passionBlock">
            <div className="passionBlockContent">
              <div className="passionBlockTitle">Farming</div>
              <ul>
                <li>Permaculture</li>
                <li>Sustainability</li>
                <li>Efficiency</li>
                <li>Organic</li>
              </ul>
            </div>
          </div>

          <div className="col-xs-12 col-sm-6 col-lg-4 passionBlock">
            <div className="passionBlockContent">
              <div className="passionBlockTitle">Audio</div>
              <ul>
                <li>Podcasts</li>
                <li>House Music</li>
                <li>Ableton Live</li>
                <li>Soundscapes</li>
              </ul>
            </div>
          </div>

          <div className="col-xs-12 col-sm-6 col-lg-4 passionBlock">
            <div className="passionBlockContent">
              <div className="passionBlockTitle">Video Games</div>
              <ul>
                <li>Unity Development</li>
                <li>Blender 3D Rendering</li>
                <li>Competative Strategy</li>
                <li>VR</li>
              </ul>
            </div>
          </div>

          <div className="col-xs-12 col-sm-6 col-lg-4 passionBlock">
            <div className="passionBlockContent">
              <div className="passionBlockTitle">AI</div>
              <ul>
                <li>Machine Learning</li>
                <li>Neural Networks</li>
                <li>Unguided Learning</li>
                <li>TensorFlow</li>
              </ul>
            </div>
          </div>

          <div className="col-xs-12 col-sm-6 col-lg-4 passionBlock">
            <div className="passionBlockContent">
              <div className="passionBlockTitle">Health</div>
              <ul>
                <li>Lifting</li>
                <li>Meditation & Presence</li>
                <li>Positivity</li>
                <li>Forward Motion</li>
              </ul>
            </div>
          </div>

          <div className="col-xs-12 col-sm-6 col-lg-4 passionBlock">
            <div className="passionBlockContent">
              <div className="passionBlockTitle">Daily Inpiration</div>
              <ul>
                <li>Product Hunt</li>
                <li>Dribbble</li>
                <li>Hacker News</li>
                <li>Twitter</li>
              </ul>
            </div>
          </div>
        </div>

        <div
          className="col-xs-8 col-xs-offset-2 col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4 col-lg-2 col-lg-offset-5 subTitle"
          style={{
            flexDirection: 'column',
            marginBottom: 200,
          }}
        >
          <div className="letsMakeStuff">Lets Make Stuff</div>
          <div className="letsMakeStuffEmail">
            <div className="titleEmail socialLink">
              <a href="mailto:jeffkgabriel@gmail.com?Subject=Hey%20Jeff!" target="_top">
                {' '}
                jeffkgabriel@gmail.com{' '}
              </a>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withCookies(withRouter(Home))
